import { render, staticRenderFns } from "./createTemplate.vue?vue&type=template&id=b1ae4ef2&"
import script from "./createTemplate.vue?vue&type=script&lang=js&"
export * from "./createTemplate.vue?vue&type=script&lang=js&"
import style0 from "./createTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports